import {
  useProfessionalRequests,
  useRejectProfessionalRequest,
  useUpdateUserTier,
} from '../../hooks/useAdmin'

export default function AdminProfessionalRequestsPage() {
  const { data, isLoading, isError } = useProfessionalRequests()
  const approveMutation = useUpdateUserTier()
  const rejectMutation = useRejectProfessionalRequest()

  return (
    <div>
      <h1 className="text-lg font-semibold text-gray-900 mb-1">Professional-tier requests</h1>
      <p className="text-sm text-gray-500 mb-4">
        Approving sets the account's credibility_tier to verified_professional, raising its
        fusion weight. Rejecting leaves the tier unchanged.
      </p>

      {isLoading && <p className="text-sm text-gray-500">Loading requests…</p>}
      {isError && <p className="text-sm text-red-600">Failed to load requests.</p>}

      {data && data.length === 0 && (
        <p className="text-sm text-gray-500">No pending requests.</p>
      )}

      <div className="space-y-3">
        {data?.map((r) => (
          <div key={r.id} className="rounded-xl border border-gray-200 bg-white px-4 py-3">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-semibold text-gray-900">{r.username}</p>
                <p className="text-xs text-gray-500">{r.email}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button
                  type="button"
                  disabled={approveMutation.isPending}
                  onClick={() => approveMutation.mutate({ userId: r.id, tier: 'verified_professional' })}
                  className="rounded-lg bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white text-xs font-semibold px-3 py-1.5 transition"
                >
                  Approve
                </button>
                <button
                  type="button"
                  disabled={rejectMutation.isPending}
                  onClick={() => rejectMutation.mutate(r.id)}
                  className="rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-50 text-gray-700 text-xs font-semibold px-3 py-1.5 transition"
                >
                  Reject
                </button>
              </div>
            </div>
            {r.professional_details && (
              <p className="mt-2 text-sm text-gray-700 whitespace-pre-wrap">{r.professional_details}</p>
            )}
            {r.created_at && (
              <p className="mt-2 text-xs text-gray-400">
                Requested {new Date(r.created_at).toLocaleString()}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
